import React from 'react'
import { inject, observer } from 'mobx-react'

import { CustomSelect } from '../../components/select'

export const ContractSelector = inject('contractsStore')(observer(({contractsStore,...props}) =>
<CustomSelect {...props}
  options={contractsStore.options}
/>))
